<template>
	<div class="l-divider" :class="border_style" v-bind="$attrs"></div>
</template>

<script>
export default {
	name: "l-divider",
	props: {
		type: {
			type: String,
		},
	},
	computed: {
		border_style() {
			switch (this.$props.type) {
				case "solid":
					return ["l-divider-solid"];
				default:
					return ["l-divider-dashed"];
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.l-divider {
	border: none;
	margin: 20px 0;
	height: 0;

	&.l-divider-dashed {
		border-bottom: dashed 1px $border-color-normal;
	}

	&.l-divider-solid {
		border-bottom: solid 1px $border-color-normal;
	}
}
</style>
